import { BLUE_RGB } from "utils/colorsTheme";

export const styles = () => ({
  thTable: {
    fontSize: ".875rem",
    fontWeight: "bold",
    color: BLUE_RGB,
  },
});
